<template>
  <div class="to-live-map-button cursor-pointer" @click="handleClick">
    <div class="menu-icon-button">
      <span class="menu-icon"></span>
      <span>{{ buttonText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToLiveMapButton",
  props: {
    handleClick: {
      type: Function,
      default: () => {},
    },
    buttonText: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_mixin.scss";
@import "@/assets/scss/aisea/_variables.scss";

.to-live-map-button {
  display: inline-flex;
  padding: 10px 20px;
  align-items: center;
  gap: 10px;
  border-radius: 30px;
  background: $aisea-gray-black;
  user-select: none;

  &:hover {
    background: $aisea-gray;
  }

  &:active {
    background: $aisea-mouse-gray;
  }

  .menu-icon-button {
    width: 108px;
    height: 15px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .menu-icon {
    width: 15px;
    height: 15px;
    background: url("~@/assets/images/icons/lolcal/arrow_circle_left.svg")
      no-repeat;
    background-size: contain;
  }
}
</style>
